"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
exports.withParentClass = function (Component) { return function (props) {
    var containerClassName = props.containerClassName, tag = props.tag, rest = __rest(props, ["containerClassName", "tag"]);
    var classNames = classnames('p-textbox', containerClassName);
    return (React.createElement("div", { "data-tag": tag, className: classNames },
        React.createElement(Component, __assign({}, rest))));
}; };
exports.default = exports.withParentClass;
//# sourceMappingURL=withParentClass.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/textbox/build/control/hocs/common/withParentClass.js
// module id = 915
// module chunks = 0